module.exports = __webpack_public_path__ + "img/hr-tree-07-a-trunk.864c2a2d.png";